import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { useRachelStore } from '../store/rachel.store';
import { selectActiveChatIdForTeam } from '../store/rachel.store.selectors';

export const useRachelActiveChatId = () => {
  const { team } = useApplicationContext();

  return useRachelStore(selectActiveChatIdForTeam(team?.id));
};
